export default "__VITE_ASSET__CKgiBN6Z__"